module.exports = __webpack_public_path__ + "static/media/trash-can.110484b1.svg";